import React, { useContext, useEffect, useState, useRef } from 'react';
import { Routes, Route, useNavigate, Link } from 'react-router-dom'
import DatePicker from '../components/DatePicker';
import LocationSelect from '../components/LocationSelect';
import TicketsList from '../components/TicketsList';
import Contact from '../components/Contact';
import advancedFormat from 'dayjs/plugin/advancedFormat'

import { useStripe, Elements, PaymentElement, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';

import "react-datepicker/dist/react-datepicker.css";
import { UserContext, useUser } from '../UserContext';
import { CartContext } from '../CartContext';
import { LocationContext, useTicketLocation } from '../LocationContext';
import AdminNavbar from '../components/AdminNavbar';
import { formatTime, getCalendarOverwrites } from '../helpers';
import { Container } from '@mui/system';
import { Alert, AlertTitle, FormControl, FormControlLabel, FormHelperText, FormLabel, InputAdornment, InputLabel, OutlinedInput, Radio, RadioGroup, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { auth, db } from '../firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import Fab from '@mui/material/Fab';
import PersonIcon from '@mui/icons-material/Person';
import { differenceInCalendarDays, format, parse } from 'date-fns';
import { defaultEndTime, defaultMaxGroups, defaultMaxPeople, defaultMaxPeoplePerLocation, defaultSlotSize, defaultStartTime, QuizItems } from 'shared';
import { AccessTime, Event, Label, LocalActivity, LocalOffer, LocationOn, PinDrop, PinDropOutlined, PinDropRounded } from '@mui/icons-material';
import dayjs from 'dayjs';
import { zonedTimeToUtc } from 'date-fns-tz';
import TimeSlotSelector, { checkSlotAvailable, useSlotsInfo } from '../components/TimeSlots';
import { useCheckoutSession } from '../hooks/checkout';

dayjs.extend(advancedFormat);

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const CheckoutForm = ({ paymentIntentId, totalAmount, handleNext, onProcessing }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);
  const processingRef = useRef(false);
  const paymentConfirmed = useRef(false);
  const [showError, setShowError] = useState();
  const navigate = useNavigate();
  const cart = useContext(CartContext)
  const [hasAgreed, setHasAgreed] = useState(false);


  const handleLoadError = (event) => {
    setShowError(event.error.message);
    console.log(event.error.message)
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements || processingRef.current) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    processingRef.current = true;
    setIsProcessing(true);
    onProcessing?.(true);
    setShowError(null)

    try {
      if (!paymentConfirmed.current) {
        const result = await stripe.confirmPayment({ elements, redirect: 'if_required' });
        if (result.error) {
          setShowError(result.error.message);
          return;
        }
        paymentConfirmed.current = true;
      }

      const response = await fetch(process.env.REACT_APP_FN_URL + '/checkout', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ paymentIntentId })
      }).then(res => res.json())

      if (response.status === 'success') {
        // navigate(`/success/${response.purchaseId}`);
        handleNext();
      } else {
        setShowError("Your payment is still processing. Please try again in a moment.");
      }

    } catch (error) {
      // TODO: display error message in UI (e.g declined, etc.)
      setShowError(paymentConfirmed.current ? 'Your payment was submitted. Please try again to finish loading your tickets.' : error.message)
      setIsProcessing(false);
    } finally {
      processingRef.current = false;
      setIsProcessing(false);
      onProcessing?.(false);
    }
  };

  return (
    <>
      {showError && <Alert severity="error">{showError}</Alert>}
      <form onSubmit={handleSubmit}>
        <PaymentElement onLoadError={handleLoadError} />   
                  {/* Checkbox to agree */}
                  {/* <FormControlLabel
        style={{margin: '20px 0 20px 0'}}
          control={
            <Checkbox
              name="agree"
              onChange={(event) => {
                setHasAgreed(event.target.checked);
              }}
            />
          }
          label={<><b>I agree to and acknowledge:</b><br />
            <ul>
              <li>The Terms and Conditions of entry.</li>
              <li>That there may be wait time to go inside (extended during holidays and weekends).</li>
              <li>That I can see the current wait time on Live Queue or message Live Chat.</li>
              <li>That I will join Virtual Queue once I arrive at the venue by speaking to the staff.</li>
            </ul>
          </>}
        />    */}
        <Box sx={{my: 2}}>
          <b>I agree to and acknowledge:</b><br />
            <ul>
              <li><a href="https://housedownunder.com.au/terms-conditions/" target="_blank" rel="noopener noreferrer">The Terms and Conditions of entry.</a></li>
              <li><a href="https://housedownunder.com.au/refunds-policy/" target="_blank" rel="noopener noreferrer">The House Down Under Refund Policy.</a></li>
            </ul>
        </Box>
        <LoadingButton
          type="submit"
          disabled={!stripe || !elements} // || !hasAgreed}
          loading={isProcessing}
          variant="contained"
          fullWidth
          color="success"
          size="large"
          sx={{ mt: 1, mr: 1, borderRadius: '10px', fontWeight: 'bold'}}>
          {paymentConfirmed.current ? 'Get my tickets' : `Agree and Pay ($${totalAmount / 100})`}
        </LoadingButton>
      </form>
    </>
  );
};

function TicketPage(props) {
  const [startDate, setStartDate] = useState(null)
  const [options, setOptions] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [loggedInUser, authLoading, error] = useAuthState(auth);

  const navigate = useNavigate();
  const cart = useContext(CartContext)
  const [user, setUser] = useUser();
  const [ticketLocation, setTicketLocation] = useTicketLocation()
  const [couponCode, setCouponCode] = useState(""); // Form field
  // Verified discount for coupon
  const [discount, setDiscount] = useState({
    validating: false,
    message: "",
    code: "",
    percent: 0,
    voucherAmountRemaining: 0,
  });

  const [disabledDates, setDisabledDates] = useState([]);
  // BUG WITH IFRAME ACCESS
  const [localUserId, setLocalUserId] = useState(); //useState(localStorage.getItem("userId"));
  const [hasAgreed, setHasAgreed] = useState(false);
  const [selectedTime, setSelectedTime] = useState();
  const [overwrites, setOverwrites] = useState([]);
  const { currentSession, createCheckoutSession, expireSession, renewSession, rememberPaymentAttempt, countDown } = useCheckoutSession();
  const [reservation, setReservation] = useState();
  const [checkoutError, setCheckoutError] = useState('');
  const [initializingPayment, setInitializingPayment] = useState(false);
  const [confirmingPayment, setConfirmingPayment] = useState(false);
  const [paymentUncertain, setPaymentUncertain] = useState(false);
  const busy = useRef(false);
  const paymentRequest = useRef();
  const paymentAttempt = useRef();
  const quantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
  const cartKey = JSON.stringify(cart.items.map(({ id, quantity }) => ({ id, quantity })).sort((a, b) => a.id.localeCompare(b.id)));
  const previousCartKey = useRef(cartKey);

  const newAttemptId = () => Array.from(window.crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
  const resetPayment = () => {
    paymentRequest.current = undefined;
    paymentAttempt.current = undefined;
    rememberPaymentAttempt?.(undefined);
    setPaymentUncertain(false);
    setOptions({});
  };
  const showCheckoutError = error => {
    const code = error.code;
    if (code === 'invalid_booking_time' || code === 'slot_unavailable') {
      setCheckoutError(code === 'slot_unavailable' ? 'That time is no longer available. Choose another time below.' : 'Please choose a time to continue. Your details are saved.');
      setActiveStep(0);
      setSelectedTime();
      setReservation();
      resetPayment();
    } else {
      setCheckoutError(code === 'payment_in_progress' ? 'Your payment is still being processed. Please wait a moment and try again.' : 'We couldn’t complete that check. Your details are saved. Please try again.');
    }
  };

  const paymentApi = async body => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 25000);
    try {
      const response = await fetch(process.env.REACT_APP_FN_URL + '/initPayment', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: controller.signal, body: JSON.stringify(body),
      });
      const result = await response.json();
      if (!response.ok || result.code || (!result.purchaseId && result.status !== 'cancelled')) {
        throw Object.assign(new Error(result.code || 'payment_check_unavailable'), { code: result.code });
      }
      return result;
    } finally { clearTimeout(timeout); }
  };

  const cancelPayment = async () => {
    const id = paymentAttempt.current || currentSession?.paymentAttemptId;
    if (!id) return true;
    const result = await paymentApi({ action: 'cancel', paymentAttemptId: id });
    if (result.status === 'success') {
      setOptions(result);
      setActiveStep(3);
      return false;
    }
    resetPayment();
    return true;
  };

  useEffect(() => {
    let cancelled = false;
    setOverwrites([]);
    setDisabledDates([]);
    if (ticketLocation?.id) {
      getCalendarOverwrites(ticketLocation.id, true).then(result => {
        if (cancelled) return;
        setOverwrites(result);
        setDisabledDates(result.filter(day => day.blocked));
      }).catch(() => { /* The authoritative check before payment can be retried. */ });
    }
    return () => { cancelled = true; };
  }, [ticketLocation?.id]);

  const changeLocation = location => {
    if (busy.current) return;
    if (location?.id !== ticketLocation?.id) {
      setSelectedTime();
      setStartDate(null);
      setReservation();
      setCheckoutError('');
    }
    setTicketLocation(location);
  };

  const initPayment = async () => {
    if (busy.current) return;
    busy.current = true;
    setInitializingPayment(true);
    setCheckoutError('');
    try {
      if (!reservation) throw Object.assign(new Error(), { code: 'invalid_booking_time' });
      const { selection, tickets, session } = reservation;
      if (!paymentRequest.current) {
        const available = await checkSlotAvailable({ id: selection.locationId, timeZone: selection.timeZone }, dayjs(selection.visitDate), selection.timeSlot, selection.groupSize, { excludeSessionId: session.id });
        if (!available) throw Object.assign(new Error(), { code: 'slot_unavailable' });
        if (session.expiresAt <= new Date()) await renewSession();
        const attemptId = paymentAttempt.current || session.paymentAttemptId || newAttemptId();
        paymentAttempt.current = attemptId;
        rememberPaymentAttempt?.(attemptId);
        paymentRequest.current = {
          discountCode: discount.code || couponCode,
          ticketLocation: selection.locationId,
          startDate: zonedTimeToUtc(selection.visitDate + 'T00:00:00', selection.timeZone).toISOString(),
          selectedDateTime: zonedTimeToUtc(selection.visitDate + 'T' + selection.timeSlot + ':00', selection.timeZone).toISOString(),
          bookingSelection: selection, checkoutSessionId: session.id, paymentAttemptId: attemptId,
          tickets, user: { ...user },
        };
      }
      setPaymentUncertain(true);
      let result;
      for (let retry = 0; retry < 3; retry++) {
        try { result = await paymentApi(paymentRequest.current); break; }
        catch (error) {
          if (error.code !== 'payment_attempt_pending' || retry === 2) throw error;
          await new Promise(resolve => setTimeout(resolve, (retry + 1) * 600));
        }
      }
      setOptions(result);
      if (result.bookingSelection) setReservation(value => ({ ...value, selection: result.bookingSelection }));
      setPaymentUncertain(false);
      setActiveStep(result.status === 'success' ? 3 : 2);
      if (result.status === 'success') expireSession({ forgetOnError: true }).catch(() => {});
      window.gtag?.('event', 'continue_contact');
    } catch (error) {
      showCheckoutError(error);
    } finally {
      busy.current = false;
      setInitializingPayment(false);
    }
  };

  const discountCodeValidate = (discountCode) => {
    setDiscount({...discount, validating: true});
    let defaultMessage = "Coupon not found or expired";
    fetch(process.env.REACT_APP_FN_URL + "/discountCodeValidate", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discountCode })
    })
    .then(res => res.json())
    .then(data => {
      if (data.code) {
        if (data.percent) {
          defaultMessage = `Discount code ${data.code} applied: -${data.percent}%`;
        }
        if (data.voucherAmountRemaining) {
          defaultMessage = `Voucher code ${data.code} applied: $${data.voucherAmountRemaining}`;
        }
      }
      setDiscount({...discount, ...data, validating: false, message: defaultMessage});
    }).catch(error => {
      console.log(error);
      setDiscount({...discount, validating: false, message:defaultMessage});
    });
  }

  const dayOfWeek = startDate?.format('dddd')?.toLowerCase();

  const {slotsInfo, isLoading} = useSlotsInfo(ticketLocation, startDate, currentSession?.id);

  const [disabledTimes, setDisabledTimes] = useState([]);
  useEffect(() => {
    // loops over all times and if the groups or groupSize is greater than the max, it adds it to the disabled times
    const disabledTimes = [];
    for(const time in slotsInfo) {
      if(slotsInfo[time].groups + 1 > defaultMaxGroups 
        || slotsInfo[time].groupSize + quantity > (defaultMaxPeoplePerLocation[ticketLocation?.id] || defaultMaxPeople))
        disabledTimes.push(time);
    }
    setDisabledTimes(disabledTimes);
  }, [slotsInfo, quantity, ticketLocation?.id])

  useEffect(() => {
    if (previousCartKey.current === cartKey) return;
    previousCartKey.current = cartKey;
    // Keep the chosen time. The existing Continue action rechecks the new quantity.
    if (!paymentRequest.current) {
      setReservation();
      if (activeStep === 1) {
        setActiveStep(0);
        setCheckoutError('Your ticket quantity changed. Please continue to confirm your time. Your details are saved.');
      }
    }
  }, [cartKey, activeStep]);

  const [checkingAvailability, setCheckingAvailability] = useState(false);
  const reserveTickets = async () => {
    if (busy.current) return;
    busy.current = true;
    setCheckingAvailability(true);
    setCheckoutError('');
    try {
      const selection = { locationId: ticketLocation.id, visitDate: startDate.format('YYYY-MM-DD'), timeSlot: selectedTime, timeZone: ticketLocation.timeZone || 'Australia/Sydney', groupSize: quantity };
      if (currentSession?.paymentAttemptId && !(await cancelPayment())) return;
      const available = await checkSlotAvailable(ticketLocation, startDate, selectedTime, quantity, { excludeSessionId: currentSession?.id });
      if (!available) throw Object.assign(new Error(), { code: 'slot_unavailable' });
      const session = await createCheckoutSession({ location: selection.locationId, visitDate: selection.visitDate, timeZone: selection.timeZone, date: zonedTimeToUtc(selection.visitDate + 'T00:00:00', selection.timeZone), timeSlot: selection.timeSlot, groupSize: quantity });
      setReservation({ selection, session, locationName: ticketLocation.name, tickets: cart.items.map(({ id, quantity }) => ({ id, quantity })) });
      resetPayment();
      setActiveStep(1);
      window.gtag?.('event', 'continue_tickets');
    } catch (error) { showCheckoutError(error); }
    finally { busy.current = false; setCheckingAvailability(false); }
  };

  const customHours = overwrites.find(d => d.date === startDate?.format('YYYY-MM-DD') && d.time);

  const steps = [
    {
      name: 'tickets',
      content: <fieldset disabled={checkingAvailability} style={{ border: 0, margin: 0, padding: 0, minWidth: 0 }}>
      {!ticketLocation && <Box sx={{my: 2, textAlign: 'center', fontWeight: 'medium'}}>Please select a location</Box>}
      <Box component="section" sx={{ my: 2, width: '100%'}}>
        {/* Location */}
        <LocationContext.Provider value={{ ticketLocation, setTicketLocation: changeLocation }}>
          <LocationSelect />
        </LocationContext.Provider>
      </Box>
  
      {ticketLocation && <React.Fragment>
        <Box component="section" sx={{ my: 2, display: 'flex', justifyContent: "start", borderBottom: '1px solid #ccc'}}>
          {/* Date */}
            <DatePicker
            selected={startDate}
            onChange={(date) => {
              if (busy.current) return;
              // Reset selected time
              if (date?.format('YYYY-MM-DD') !== startDate?.format('YYYY-MM-DD')) { setSelectedTime(); setReservation(); }
              setStartDate(date && date.isValid() && !disabledDates.some((d) => d.date === date.format('YYYY-MM-DD')) && differenceInCalendarDays(date.toDate(), new Date()) >= 0 ? date : null)
            }}
            shouldDisableDate={(date) => {
              return disabledDates.some((d) => d.date === date.format('YYYY-MM-DD'));
            }}
          />
        </Box>

        <TicketsList 
        ticketLocation={ticketLocation?.id} 
        startDate={startDate ? startDate.toDate() : null} 
        />
        
        {startDate && <TimeSlotSelector 
          startTime={customHours?.time?.from || ticketLocation?.hours?.[dayOfWeek]?.from || defaultStartTime} 
          endTime={customHours?.time?.to || ticketLocation?.hours?.[dayOfWeek]?.to || defaultEndTime} 
          slotSize={defaultSlotSize} 
          selectedTime={selectedTime} 
          setSelectedTime={time => { if (!busy.current) setSelectedTime(time); }}
          selectedDate={startDate}
          timeZone={ticketLocation?.timeZone}
          disabledTimes={disabledTimes}
          isLoading={isLoading}
        />}
        
        <FormControl fullWidth sx={{ my: 1 }}>
          <OutlinedInput
            fullWidth
            id="outlined-coupon"
            className='coupon'
            endAdornment={
              <InputAdornment position="end">
                <Button
                  disabled={discount.validating || !couponCode}
                  onClick={() => discountCodeValidate(couponCode)}
                  edge="end"
                >
                  {discount.validating ? "Applying..." : "Apply"}
                </Button>
              </InputAdornment>
            }
            name="coupon"
            value={couponCode}
            onChange={event => { setCouponCode(event.target.value); setDiscount({ ...discount, code: '', percent: 0, voucherAmountRemaining: 0, message: '' }); }}
            placeholder="Coupon or Voucher (optional)"
          />
          {discount.message && <FormHelperText sx={{fontSize: 14, fontWeight: "bold"}}>{discount.message}</FormHelperText>}
        </FormControl>
        </React.Fragment>}
      </fieldset>,
      buttons: <>
        {ticketLocation && startDate && selectedTime && <Button
          size="large"
          fullWidth
          sx={{ mt: 1, mr: 1, borderRadius: '10px', fontWeight: 'bold' }}
          variant="contained"
          // check if agree checkbox is ticket
          disabled={cart.items.length < 1 || discount.validating || checkingAvailability}
          onClick={reserveTickets}
        >
          {cart.getTotalCost(discount.percent, discount.voucherAmountRemaining)}$ - Get It
        </Button>}
      </>,
    },
    {
      name: 'contact',
      content:
      <>
      <Box sx={{my: 2}}>
      Contact Details
      </Box>
        <UserContext.Provider value={{ user, setUser }} >
          <Contact handleNext={initPayment} busy={initializingPayment} inputsDisabled={initializingPayment || paymentUncertain} />
        </UserContext.Provider>
        </>,
      buttons: <>
        <Button
          fullWidth
          onClick={handleBack}
          disabled={initializingPayment}
          sx={{ mt: 1, mr: 1 }}
        >
          Back
        </Button>
      </>
    },
    {
      name: 'payment',
      content: stripePromise && options.clientSecret ?
        <>
          <Box sx={{mb: 2}}>
            <p>Payment</p>
            <ul style={{listStyleType: 'none', padding: 0, margin: 0}}>
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <LocationOn color="disabled" sx={{ display: 'inline', marginRight: 1}} /> {reservation?.locationName}
              </li >
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <Event color="disabled"  sx={{ display: 'inline', marginRight: 1}} /> {reservation && dayjs(reservation.selection.visitDate).format('dddd, Do MMMM')}
              </li >
              {reservation?.selection.timeSlot && <li style={{ display: 'flex', alignItems: 'center' }}>
                <AccessTime color="disabled"  sx={{ display: 'inline', marginRight: 1}} /> {reservation.selection.timeSlot}
              </li >}
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <LocalActivity color="disabled" sx={{display: 'inline', marginRight: 1}} /> {reservation?.selection.groupSize} {reservation?.selection.groupSize === 1 ? 'ticket' : 'tickets'}
              </li> 
              {options?.discountCode && <li style={{ display: 'flex', alignItems: 'center' }}>
                <LocalOffer color="disabled" sx={{display: 'inline', marginRight: 1}} /> Discount code: {options?.discountCode}
              </li>}      
            </ul>
   
          </Box>
          <Elements stripe={stripePromise} options={options}>
            <CheckoutForm onProcessing={setConfirmingPayment} paymentIntentId={options.id} totalAmount={options.totalAmount} handleNext={() => {
              // expire checkout session when payment is successful
              expireSession({ forgetOnError: true }).catch(() => {});
              setActiveStep(3);
            }} />
          </Elements>     
          <Button
            fullWidth
            onClick={handleBack}
            disabled={confirmingPayment || initializingPayment}
            sx={{ mt: 1, mr: 1 }}
          >
            Back
          </Button>
        </>
        : <Box sx={{my: 2}}>Loading...</Box>
    },
    {
      name: 'quiz',
      content: <>
        <Box sx={{my: 2}}>
          How did you hear about us?
        </Box>
        <FormControl>
          <RadioGroup
            onChange={(event) => {
              submitQuiz(event.target.value, options);
            }}
            name="radio-buttons-group"
          >
            {QuizItems.map((item) => (
              <FormControlLabel key={item} value={item} control={<Radio />} label={item} />
            ))}
          </RadioGroup>
        </FormControl>
      </>,
      buttons: <>
        {/* <Button
          fullWidth
          onClick={handleBack}
          sx={{ mt: 1, mr: 1 }}
        >
          Back
        </Button> */}
      </>,
    },
  ];

  async function handleBack() {
    if (busy.current || confirmingPayment) return;
    busy.current = true;
    setInitializingPayment(true);
    setCheckoutError('');
    try {
      if (paymentAttempt.current && !(await cancelPayment())) return;
      if (activeStep === 1) {
        await expireSession();
        setReservation();
      }
      resetPayment();
      setActiveStep(activeStep - 1);
    } catch (error) { showCheckoutError(error); }
    finally { busy.current = false; setInitializingPayment(false); }
  }

  const submitQuiz = (answer, options) => {
    fetch(process.env.REACT_APP_FN_URL + "/submitQuiz", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ answer, purchaseId: options.purchaseId })
    })

    navigate(`/success/${options.purchaseId}`);
  }


  return (
    <>
      {loggedInUser && <AdminNavbar />}
      <Container component="main" maxWidth="xs">
        {localUserId && <Fab sx={{
          position: 'absolute',
          top: loggedInUser ? 70 : 16,
          right: 16,
        }}
          color="primary"
          aria-label="edit"
        >
          <Link to={`/edit-user-data/${localUserId}`}>
            <PersonIcon style={{ color: 'white' }} />
          </Link>
        </Fab>}


        {checkoutError && <Alert severity="warning" sx={{ my: 2 }}>{checkoutError}</Alert>}
        {initializingPayment && <Box role="status" sx={{ my: 2 }}>Checking your booking…</Box>}
        {activeStep === 1 && currentSession && <Box sx={{ my: 2 }}>
          <Alert severity="info">
            {countDown > 0 ? <>Your tickets are held for <b>{formatTime(countDown)}</b>.</> : 'We’ll check your chosen time again when you continue. Your details are saved.'}
          </Alert>
        </Box>}

        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.name}>
              <StepContent>
                {step.content}
                <Box sx={{ mb: 2 }}>
                  {step.buttons}
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Container>
    </>
  );
  
}

export default TicketPage;
